import md5 from 'js-md5';

const FP_CACHE_KEY = 'terminalMac';
const FINGERPRINT_PATTERN = /^[a-f0-9]{32}$/i;

function getCanvasFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return '';

    const text = 'terminal-mac-fingerprint';
    context.textBaseline = 'top';
    context.font = '14px Arial';
    context.fillStyle = '#f60';
    context.fillRect(125, 1, 62, 20);
    context.fillStyle = '#069';
    context.fillText(text, 2, 15);
    context.fillStyle = 'rgba(102, 204, 0, 0.7)';
    context.fillText(text, 4, 17);
    return canvas.toDataURL();
  } catch (e) {
    return '';
  }
}

function getBrowserInfo() {
  const nav = typeof navigator === 'undefined' ? {} : navigator;
  const display = typeof screen === 'undefined' ? {} : screen;

  return [
    nav.userAgent || '',
    nav.language || '',
    nav.platform || '',
    nav.vendor || '',
    `${display.width || 0}x${display.height || 0}`,
    display.colorDepth || 0,
    new Date().getTimezoneOffset(),
    nav.hardwareConcurrency || 0,
    nav.deviceMemory || 0,
    getCanvasFingerprint()
  ].join('|');
}

/**
 * 获取发送给 API 的稳定设备指纹，并缓存为 32 位 MD5 值。
 */
export function getDeviceFingerprint() {
  try {
    const cached = localStorage.getItem(FP_CACHE_KEY);
    if (cached && FINGERPRINT_PATTERN.test(cached)) {
      return cached;
    }
  } catch (e) {
    // 隐私模式可能禁用存储，仍可使用当前浏览器信号生成指纹。
  }

  const fingerprint = md5(getBrowserInfo());
  try {
    localStorage.setItem(FP_CACHE_KEY, fingerprint);
  } catch (e) {
    // 缓存失败不影响请求继续携带设备指纹。
  }
  return fingerprint;
}

// 保留参考项目中的旧名称，便于后续代码兼容。
export const getTerminalMac = getDeviceFingerprint;

export function resetTerminalMac() {
  try {
    localStorage.removeItem(FP_CACHE_KEY);
  } catch (e) {
    // 忽略受限浏览器环境中的存储异常。
  }
}
